<template>
  <div class="form-group">
    <label class="tb-label layer-name">{{element.name}}</label>

    <qr-code-url
      v-model:url="permalink"
      v-model:short-url="shortLink"
      :provider="!!provider"
      :item="this.graphic"
      :element="this.element"
      :entity-id="this.graphic.template_id"
      :data-test="`graphics-editor-${this.element.id}-permalink`"
    />

    <div class="tb-form-group mt-4 flex items-center" data-entity="producer-editor-toggleBackgroundColorPicker" data-test="graphics-editor-qrCode-backgroundColor">
      <label class="tb-label mb-0 mr-2">Background color</label>

      <colorpicker
        :color="element.backgroundColor"
        :large="true"
        show-buttons
        @change="$emit('value', { value: $event, field: 'backgroundColor'} )"
      />
    </div>

    <div class="tb-form-group flex items-center" data-entity="producer-editor-toggleDotColorPicker" data-test="graphics-editor-qrCode-dotColor">
      <label class="tb-label mb-0 mr-2">Dot color</label>

      <colorpicker
        :color="element.dotColor"
        :large="true"
        show-buttons
        @change="$emit('value', { value: $event, field: 'dotColor'} )"
      />
    </div>

    <div class="tb-form-group">
      <div class="tb-checkbox">
        <input
          type="checkbox"
          id="hasLogo"
          v-model="hasLogo"
          data-entity="producer-editor-toggleImageLogo"
          data-test="graphics-editor-qrCode-logo"
          @change="$emit('value', { value: $event.target.checked, field: 'hasLogo'} )"
        />

        <label for="hasLogo">Show image logo</label>
      </div>
    </div>

    <template v-if="element.hasLogo">
      <div class="tb-form-group">
        <div v-if="element.logoUrl" class="media-upload-wrapper">
          <div class="media" :style="{ 'background-image' : 'url(' + element.logoUrl + ')' }"></div>
          <div class="edit-media">
            <button
              class="tb-btn tb-btn-contained on-image"
              data-entity="producer-editor-editLogo"
              data-test="graphics-editor-qrCode-logoSelect"
              @click="selectAsset"
            >
              <span class="fas fa-pencil-alt" />
            </button>
          </div>
        </div>

        <button
          v-else
          class="tb-btn tb-btn-contained medium-em"
          data-entity="producer-editor-selectLogo"
              data-test="graphics-editor-qrCode-logoSelect"
          @click="selectAsset"
        >
          <span class="fas fa-image mr-1"></span>
          Choose image
        </button>
      </div>
    </template>
  </div>
</template>

<script>
/* eslint-disable vue/no-mutating-props */
import QrCodeUrl from '../../../../shared/QrCodeUrl.vue';

export default {
  props: ['graphic', 'element', 'graphic_fields'],

  components: {
    QrCodeUrl,
  },

  computed: {
    computedFields() {
      return (
        this.graphic.fields?.[this.element.id]
        || this.graphic_fields?.[this.element.id]
      ) ?? {};
    },
    hasLogo: {
      get() {
        return this.element.hasLogo;
      },

      set(v) {
        this.$emit('value', { value: v, field: 'hasLogo' });
      },
    },

    permalink: {
      get() {
        return this.computedFields.permalink ?? this.element.permalink;
      },

      set(v) {
        this.$emit('value', { value: v.trim(), field: 'permalink' });
      },
    },

    shortLink: {
      get() {
        return this.computedFields.shortLink ?? this.element.shortLink ?? '';
      },
      set(value) {
        this.$emit('value', { value, field: 'shortLink' });
      },
    },

    provider() {
      return this.element?.data?.provider;
    },
  },

  methods: {
    selectAsset() {
      this.$store.dispatch('toggleAssetModal', { toggled: true, type: 'image' });

      window.assetmanfn = (asset, meta = {}) => {
        this.element.logoUrl = asset.media_url;
        this.element.logoMeta = meta;
        this.$emit('value', { value: asset.media_url, field: 'logoUrl' });
        this.$emit('value', { value: meta, field: 'logoMeta' });
        this.$store.dispatch('toggleAssetModal', { toggled: false, type: 'image' });
      };
    },
  },
};
</script>
